import React from 'react'
import Hero from '../components/Hero'
import Services from '../components/Services'
import Products from '../components/Products'
import About from '../components/About'
import Contact from '../components/Contact'

const Home = () => {
    return (
        <div className='flex-grow'>
            <Hero />
            <Services />
            <Products />
            <About />
            <Contact />
        </div>
    )
}

export default Home
